export var TriggerType;
(function (TriggerType) {
    TriggerType["BOOKING_PERIOD_LENGTH"] = "BOOKING_PERIOD_LENGTH";
    TriggerType["NUMBER_OF_RESOURCES"] = "NUMBER_OF_RESOURCES";
    TriggerType["NUMBER_OF_RESOURCES_IN_GROUP"] = "NUMBER_OF_RESOURCES_IN_GROUP";
})(TriggerType || (TriggerType = {}));
